import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef, useState } from "react";
import { useAtom } from "jotai";
import { Check, Monitor, Moon, Sun } from "lucide-react";
import { themePreferenceAtom } from "../atoms/themeAtom";
import styles from "./ThemeToggle.module.scss";
const OPTIONS = [
    { value: "light", label: "Ljust", icon: Sun },
    { value: "dark", label: "Mörkt", icon: Moon },
    { value: "auto", label: "Auto", icon: Monitor },
];
export function ThemeToggle() {
    const [preference, setPreference] = useAtom(themePreferenceAtom);
    const [open, setOpen] = useState(false);
    const containerRef = useRef(null);
    useEffect(() => {
        if (!open) {
            return;
        }
        function handlePointerDown(event) {
            if (containerRef.current && !containerRef.current.contains(event.target)) {
                setOpen(false);
            }
        }
        function handleKeyDown(event) {
            if (event.key === "Escape") {
                setOpen(false);
            }
        }
        document.addEventListener("mousedown", handlePointerDown);
        document.addEventListener("keydown", handleKeyDown);
        return () => {
            document.removeEventListener("mousedown", handlePointerDown);
            document.removeEventListener("keydown", handleKeyDown);
        };
    }, [open]);
    return (_jsxs("div", { className: styles.container, ref: containerRef, children: [_jsx("button", { type: "button", className: styles.trigger, onClick: () => setOpen((prev) => !prev), "aria-haspopup": "true", "aria-expanded": open, "aria-label": "Byt tema", children: _jsx(Sun, { size: 18 }) }), open && (_jsx("div", { className: styles.menu, role: "menu", children: OPTIONS.map((option) => (_jsxs("button", { type: "button", role: "menuitemradio", "aria-checked": preference === option.value, className: styles.menuItem, onClick: () => {
                        setPreference(option.value);
                        setOpen(false);
                    }, children: [_jsxs("span", { className: styles.itemLabel, children: [_jsx(option.icon, { size: 16, className: styles.itemIcon }), option.label] }), preference === option.value && _jsx(Check, { size: 16, className: styles.check })] }, option.value))) }))] }));
}
